import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

const CashManagementInitializer = (): ReactElement => <Outlet />;

CashManagementInitializer.displayName = 'Page cash management initializer component';

export default CashManagementInitializer;
